import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { environment } from '../../../environments/environment.prod';

@Component({
	selector: 'app-paginador',
	templateUrl: './paginador.component.html',
	styleUrls: ['./paginador.component.css']
})
export class PaginadorComponent implements OnInit {

	@Input() totalPaginas:number;
	@Input() currentPage:number = 1;
	showControl:boolean = false;
	newPage:string;
	@Output() eventSuccess = new EventEmitter<any>();
	@Output() eventFail = new EventEmitter<any>();

	constructor( ) { }

	ngOnInit() {

	}

	fnAccionControl(){
		this.showControl = !this.showControl;
	}

	fnIrPagina(){
		if( this.newPage === "" ){
			this.eventFail.emit( environment.alerta.paginacion.vacio );
		}else if( !environment.validacion.numero.test( `${this.newPage}` )){
			this.eventFail.emit( environment.alerta.paginacion.formato );
		}else if( parseInt(this.newPage) < 1 || parseInt(this.newPage) >  this.totalPaginas ){
			this.eventFail.emit( environment.alerta.paginacion.limite );
		}else{
			this.currentPage = (parseInt(this.newPage) - 1);
			this.fnAccionControl();
			this.eventSuccess.emit( this.currentPage );
		}
	}

	fnAccionPaginacion( siguiente:boolean ){
		if( siguiente ){
			if( ( this.currentPage ) < this.totalPaginas ){
				this.currentPage = this.currentPage + 1;
				this.eventSuccess.emit( this.currentPage );
			}
		}else{
			if( this.currentPage > 1 ){
				this.currentPage = this.currentPage - 1;
				this.eventSuccess.emit( this.currentPage );
			}
		}
	}
	

}
